import { render, staticRenderFns } from "./MenuDrawer.vue?vue&type=template&id=905b0b40&scoped=true"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"
import style0 from "./MenuDrawer.vue?vue&type=style&index=0&id=905b0b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905b0b40",
  null
  
)

export default component.exports